import React from "react";
import { Form } from "react-bootstrap";
import Blue_btn from "../../../../../../common_components/common_btn/blue_btn/Blue_btn";
import Orange_btn from "../../../../../../common_components/common_btn/orange_btn/Orange_btn";
import { useNavigate } from "react-router-dom";
function Step1({ onNext }) {
  const navigate = useNavigate();
  return (
    <div className="mt-4 card_box">
      <div className="heading_text_holder">
        <h1>What is the correct form? '_____ do you speak French?'</h1>
      </div>

      <Form className="mt-3 lt_options">
        <Form.Group className="mb-3">
          <Form.Check type="radio" name="q1" label="Is" className="lt_option" />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Check
            type="radio"
            name="q1"
            label="Be (subj.)"
            className="lt_option"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Check
            type="radio"
            name="q1"
            label="Will be"
            className="lt_option"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Check
            type="radio"
            name="q1"
            label="Would be"
            className="lt_option"
          />
        </Form.Group>
      </Form>

      <div className="btn_holder">
        <Orange_btn
          btn_text="Cancel"
          onClick={() => navigate("/portal/student/language-test")}
        />
        <Blue_btn btn_text="Next" onClick={onNext} />
      </div>
    </div>
  );
}

export default Step1;
